<template>
    <v-app>
        <core-header/>
        <core-view/>
        <core-footer/>
    </v-app>
</template>

<script>
    import store from "@/store"
    import {mapGetters} from 'vuex'

    export default {
        name: 'App',
        created() {
            store.dispatch("ACTION_STARTUP")
        },
        computed: {
            ...mapGetters(['getProfile'])
        }
    }
</script>

<style lang="scss">
    @import '@/styles/index.scss';

    /* Remove in 1.2 */
    .v-datatable thead th.column.sortable i {
        vertical-align: unset;
    }
</style>
